import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { classNames } from "@ct-react/core";
import { formatWhere } from "../../hooks/format-gql-variables";
import { AnyArticleSearch } from "../../contexts/search";
import { Wrapper } from "../layout/wrapper";
import ArticleCard from "../article-card";

const SUGGESTIONS_GQL_DATA = gql`
  query CmsSuggestions($where: AnyArticleFilterInput) {
    search(where: $where, first: 20) {
      edges {
        cursor
        node {
          ... on RentalAccommodationArticle {
            id slug
            novelty recommended promoted
            images @limit(max: 10) { assets { url breakpoint } }
            address { city }
            title { value }
            lowestPrice { type onDemand value }
            features { maxGuests bedrooms bathrooms }
          }
          ... on SaleAccommodationArticle {
            id slug
            novelty recommended promoted sold
            images @limit(max: 10) { assets { url breakpoint } }
            address { city }
            title { value }
            price { onDemand value }
            features { rooms bedrooms bathrooms livingSpace plotSpace }
          }
        }
        accommodationBookingSuggestion {
          period bookable priceOnDemand
          price { amount detailed { bare discount providerCharge { amount adaptive } } }
        }
      }
      paginationInfo {
        currentPage pageCount pageSize hasNextPage hasPreviousPage
        lastPageCursor nextPageCursor previousPageCursor linkPageCursors { cursor page }
      }
    }
  }
`;

type Props = {
  className?: string;
  title: string;
  subTitle?: string;
  criteria: AnyArticleSearch;
}

const SuggestedItem = ({ className, title, subTitle, criteria }: Props) => {


  const { data, loading } = useQuery<{ search: any }>(SUGGESTIONS_GQL_DATA, {
    ssr: false,
    variables: { where: formatWhere(criteria) }
  });

  if (loading || !data?.search || data.search.edges.length === 0)
    return null;

  const wrapperClasses = classNames("cms-foot content", className);

  return (
    <Wrapper.ScrollableList as="section" className={wrapperClasses}>
      <Wrapper.ScrollableListHeader title={title} subTitle={subTitle} />
      <Wrapper.ScrollableListContent>
        {data.search.edges.map((edge: any, index: number) => (
          <ArticleCard key={edge.node.id || index} loading={false} data={edge.node} />)
        )}
      </Wrapper.ScrollableListContent>
    </Wrapper.ScrollableList>);

};

export default SuggestedItem;
